export default __webpack_public_path__ + "media/images/mastodon-logo-black-text-claire-80502b9754e0c94675c2c1d4ae754866.svg";